import { gql } from '@apollo/client';

export const ALL_OUTCOMES_INDICATORS = gql`
  query AllOutcomeIndicators($outcomeId: ID!) {
    indicators: allOutcomeIndicators(outcomeId: $outcomeId) {
      id
      name
      definition
      unit
      measurementUnit
      dataCategory
    }
  }
`;
